export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID
export const REDIRECT_URI = import.meta.env.VITE_AUTH0_CALLBACK_URL

export const MICROSOFT_CLIENT_ID = import.meta.env.VITE_MICROSOFT_CLIENT_ID
export const MICROSOFT_TENANT_ID = import.meta.env.VITE_MICROSOFT_TENANT_ID
export const MICROSOFT_REDIRECT_URI = import.meta.env.VITE_MICROSOFT_CALLBACK_URL

export const EMPLOYEE_EMAIL_DOMAINS = (import.meta.env.VITE_EMPLOYEE_EMAIL_DOMAINS ?? '')
  .split(',')
  .map((domain: string) => domain.trim().toLowerCase())
  .filter(Boolean)
